export default "__VITE_ASSET__HZzQnvWb__"